import { SVGProps } from '@components/Icon/types';

export const UnArchive = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 21 20"
    fill="none"
    {...props}>
    <path
      d="M16.8271 18.9582H3.49382C2.88616 18.9577 2.30352 18.7161 1.87385 18.2865C1.44417 17.8568 1.20259 17.2742 1.20215 16.6665V6.6665C1.20215 6.50074 1.268 6.34177 1.38521 6.22456C1.50242 6.10735 1.66139 6.0415 1.82715 6.0415H18.4938C18.6596 6.0415 18.8185 6.10735 18.9358 6.22456C19.053 6.34177 19.1188 6.50074 19.1188 6.6665V16.6665C19.1184 17.2742 18.8768 17.8568 18.4471 18.2865C18.0174 18.7161 17.4348 18.9577 16.8271 18.9582ZM2.45215 7.2915V16.6665C2.45259 16.9426 2.56248 17.2073 2.75773 17.4026C2.95299 17.5978 3.21768 17.7077 3.49382 17.7082H16.8271C17.1033 17.7077 17.368 17.5978 17.5632 17.4026C17.7585 17.2073 17.8684 16.9426 17.8688 16.6665V7.2915H2.45215Z"
      fill={fill}
    />
    <path
      d="M10.1602 15.625C9.9944 15.625 9.83543 15.5592 9.71821 15.4419C9.601 15.3247 9.53516 15.1658 9.53516 15V10C9.53516 9.83424 9.601 9.67527 9.71821 9.55806C9.83543 9.44085 9.9944 9.375 10.1602 9.375C10.3259 9.375 10.4849 9.44085 10.6021 9.55806C10.7193 9.67527 10.7852 9.83424 10.7852 10V15C10.7852 15.1658 10.7193 15.3247 10.6021 15.4419C10.4849 15.5592 10.3259 15.625 10.1602 15.625Z"
      fill={fill}
    />
    <path
      d="M10.1601 8.89059C10.2422 8.89039 10.3235 8.90649 10.3993 8.93796C10.4752 8.96943 10.544 9.01565 10.6018 9.07392L13.1018 11.5739C13.2122 11.6924 13.2723 11.8491 13.2694 12.011C13.2666 12.1729 13.201 12.3274 13.0865 12.4419C12.972 12.5565 12.8175 12.622 12.6556 12.6249C12.4936 12.6278 12.3369 12.5677 12.2185 12.4573L10.1601 10.3998L8.10179 12.4573C7.98331 12.5677 7.8266 12.6278 7.66469 12.6249C7.50277 12.622 7.34828 12.5565 7.23377 12.4419C7.11926 12.3274 7.05366 12.1729 7.05081 12.011C7.04795 11.8491 7.10805 11.6924 7.21845 11.5739L9.71845 9.07392C9.77627 9.01565 9.84508 8.96943 9.9209 8.93796C9.99672 8.90649 10.078 8.89039 10.1601 8.89059Z"
      fill={fill}
    />
    <path
      d="M1.25056 0.447437C1.21048 0.17422 0.956494 -0.0147705 0.683277 0.0253158C0.410059 0.0654021 0.221069 0.319385 0.261156 0.592602L1.25056 0.447437ZM2.23794 7.17712L1.25056 0.447437L0.261156 0.592602L1.24853 7.32229L2.23794 7.17712Z"
      fill={fill}
    />
    <path
      d="M19.0102 0.447437C19.0503 0.17422 19.3042 -0.0147705 19.5775 0.0253158C19.8507 0.0654021 20.0397 0.319385 19.9996 0.592602L19.0102 0.447437ZM18.0228 7.17712L19.0102 0.447437L19.9996 0.592602L19.0122 7.32229L18.0228 7.17712Z"
      fill={fill}
    />
  </svg>
);

export const ICON_NAME = 'unarchive';
